import React from 'react';
import PropTypes from 'prop-types';

// Videos
import machVideo from 'assets/videos/mach-404-clip.mp4';
import betterVideo from 'assets/videos/better-404-clip.mp4';
import thinkVideo from 'assets/videos/think-404-clip.mp4';
import leftfieldVideo from 'assets/videos/leftfield-404-clip.mp4';
import newsVideo from 'assets/videos/news-404-clip.mp4';
import todayVideo from 'assets/videos/today-404-clip.mp4';
import kyvVideo from 'assets/videos/kyv-404-clip.mp4';

import verticalLink from 'lib/verticalLink';
import { getDisplayNameForVertical } from 'lib/vertical';
import { withTranslation } from 'lib/Locale/i18n';

const ERROR_VIDEOS = {
  404: {
    mach: machVideo,
    better: betterVideo,
    think: thinkVideo,
    leftfield: leftfieldVideo,
    news: newsVideo,
    today: todayVideo,
    knowyourvalue: kyvVideo,
  },
  500: {
    mach: machVideo,
    better: betterVideo,
    think: thinkVideo,
    leftfield: leftfieldVideo,
    news: newsVideo,
    today: todayVideo,
    knowyourvalue: kyvVideo,
  },
};

const ErrorMessage = ({ vertical, code, t }) => {
  const getErrorValue = (obj) => (obj[code][(obj[code][vertical] ? vertical : 'default')]) || null;

  const video = getErrorValue(ERROR_VIDEOS);
  const translatedHeadline = t([`ERROR_H2.${code}.${vertical}`, `ERROR_H2.${code}.default`]);
  const translatedText = t([`ERROR_TEXT.${code}.${vertical}`, `ERROR_TEXT.${code}.default`], { code });

  /* eslint-disable react/no-danger */
  return (
    <div className="error-message">
      <h1 className="error-message__code">
        <span className={`error-message__code-${code}`}>
          {code}
        </span>
      </h1>

      <div className="error-message__background">
        <div className="error-message__headline__container">
          <h2 className="error-message__headline" dangerouslySetInnerHTML={{ __html: translatedHeadline }} />
        </div>
        { video && (
          <video width="100%" autoPlay loop muted>
            <source src={video} type="video/mp4" />
          </video>
        )}
      </div>
      <div className="error-message__text">
        {translatedText}
        {' '}
        <a href={`/${verticalLink(vertical)}`} className="error-message__text--branded">
          {getDisplayNameForVertical(vertical)}
        </a>
        .
      </div>
    </div>
  );
  /* eslint-enable react/no-danger */
};

ErrorMessage.propTypes = {
  vertical: PropTypes.string.isRequired,
  code: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ErrorMessage);
